import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/ExclamationmarkSmallBubbleColor.tsx
const ExclamationmarkSmallBubbleColorIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21 11.504a9.5 9.5 0 1 0-5.798 8.751l3.507.942c1.24.332 2.297-.942 1.741-2.098l-1.086-2.263A9.46 9.46 0 0 0 21 11.504Z",
		fill: "#FFEF9B"
	}), /* @__PURE__ */ jsx("path", {
		d: "M11.5 12a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1ZM10 14.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
		fill: "#E4A01D"
	})]
}));
//#endregion
export { ExclamationmarkSmallBubbleColorIcon };
